import { render } from "./CartComponent.vue?vue&type=template&id=8d2d5d6a"
import script from "./CartComponent.vue?vue&type=script&lang=js"
export * from "./CartComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2009374271/src/sayuri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__